export const getSentryEnvironment = (): string | undefined => {
  const appEnv = process.env.APP_ENV;

  if (appEnv === 'dev') {
    return 'development';
  }

  return appEnv;
};
